<template>
  <div>
    <main-toolbar></main-toolbar>
    <v-layout row justify-center class="hidden-sm-and-down">
      <v-card class="surfAndScanborder" style="min-width: 50%;">
        <v-layout class="row justify-content-center">
          Der Einkauf wurde abgebrochen.
        </v-layout>
      </v-card>
    </v-layout>ShopCancel
  </div>
</template>

<script>
import MainToolbar from './toolbar/MainToolbar'

export default {
  name: 'shop-cancel',
  components: {MainToolbar}
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ShopCancel.vue